// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  margin-left: 50px;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.container .header-container {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: var(--ion-color-light);
  flex-grow: 1;
}
.container .header-container img {
  height: 50%;
  width: 50%;
  object-fit: contain;
}
.container .header-container h1 {
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 10px;
  z-index: 11;
}

.payment-options {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
.payment-options .option {
  background: var(--ion-color-light);
  border: 2px solid var(--ion-color-light);
  width: 33%;
  border-radius: 10px;
  margin: auto;
  padding: 16px 0;
  transition: all 0.05s ease-in;
  text-align: center;
  cursor: pointer;
}
.payment-options .option ion-icon {
  font-size: 40px;
  color: var(--ion-color-medium);
}
.payment-options .option p {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
}

.method-active {
  border: 2px solid var(--ion-color-primary) !important;
  background: #fff !important;
}
.method-active ion-icon {
  color: var(--ion-color-primary) !important;
}
.method-active p {
  color: var(--ion-color-primary) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/link-payment/link-payment.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kCAAA;EACA,YAAA;AACJ;AACI;EACE,WAAA;EACA,UAAA;EACA,mBAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAAN;;AAKA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAFF;AAIE;EACE,kCAAA;EACA,wCAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAII;EACE,eAAA;EACA,8BAAA;AAFN;AAKI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAHN;;AAQA;EACE,qDAAA;EACA,2BAAA;AALF;AAOE;EACE,0CAAA;AALJ;AAQE;EACE,0CAAA;AANJ","sourcesContent":["ion-title {\n  margin-left: 50px;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .header-container {\n    height: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background: var(--ion-color-light);\n    flex-grow: 1;\n\n    img {\n      height: 50%;\n      width: 50%;\n      object-fit: contain;\n    }\n\n    h1 {\n      font-size: 20px;\n      font-weight: 900;\n      margin-bottom: 10px;\n      z-index: 11;\n    }\n  }\n}\n\n.payment-options {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n\n  .option {\n    background: var(--ion-color-light);\n    border: 2px solid var(--ion-color-light);\n    width: 33%;\n    border-radius: 10px;\n    margin: auto;\n    padding: 16px 0;\n    transition: all 0.05s ease-in;\n    text-align: center;\n    cursor: pointer;\n\n    ion-icon {\n      font-size: 40px;\n      color: var(--ion-color-medium);\n    }\n\n    p {\n      margin-top: 5px;\n      font-size: 16px;\n      font-weight: 600;\n    }\n  }\n}\n\n.method-active {\n  border: 2px solid var(--ion-color-primary) !important;\n  background: #fff !important;\n\n  ion-icon {\n    color: var(--ion-color-primary) !important;\n  }\n\n  p {\n    color: var(--ion-color-primary) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
